import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { matchPath } from 'react-router';
import { clientPaths } from '../paths';

export function init(params) {
  Sentry.init({
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // dsn: process.env.REACT_APP_SENTRY_DNS,
    ...params,
  });
}

function prepareAccount(account) {
  if (!account) return null;

  return {
    id: account.id,
    name: account.name,
    active: account.active,
    status: account.status,
    mifidAccepted: account.mifidAccepted,
  };
}

function prepareUser(user) {
  if (!user) return null;

  return {
    id: user.id,
    email: user.email,
    name: user.name,
    lastname: user.lastname,
    userType: user.userType,
    status: user.status,
    identityVerified: user.identityVerified,
    verified: user.verified,
    preferredLanguage: user.preferredLanguage,
  };
}

export function captureMessage(message, params) {
  Sentry.captureMessage(message, params);
}

export const level = Sentry.Severity;

export function setUser(user) {
  Sentry.setUser(prepareUser(user));
}

export function setAccount(account) {
  Sentry.setContext('account', prepareAccount(account));
}

export function setClient(client) {
  Sentry.setContext('client', prepareUser(client));
}

export function setContext(type, params) {
  Sentry.setContext(type, params);
}

export function setTag(tag, value) {
  Sentry.setTag(tag, value);
}

export function getClientSectionFromPathname(pathname) {
  if (
    matchPath(pathname, {
      path: [
        clientPaths.accounts.profiling.base,
        clientPaths.accounts.profiling.withAccount.complete,
      ],
    })
  ) {
    return 'accounts/profiling';
  }

  if (matchPath(pathname, { path: clientPaths.accounts.infos.complete })) {
    return 'accounts/infos';
  }

  if (matchPath(pathname, { path: clientPaths.accounts.portfolioProposals.complete })) {
    return 'accounts/proposals';
  }

  if (matchPath(pathname, { path: clientPaths.accounts.portfolios.complete })) {
    return 'accounts/portfolios';
  }

  if (matchPath(pathname, { path: clientPaths.accounts.dashboard.complete })) {
    return 'accounts/dashboard';
  }

  if (matchPath(pathname, { path: clientPaths.accounts.wallet.complete })) {
    return 'accounts/wallet';
  }

  if (matchPath(pathname, { path: clientPaths.accounts.investments.complete })) {
    return 'accounts/investments';
  }

  if (matchPath(pathname, { path: clientPaths.accounts.complete })) {
    return 'accounts';
  }

  if (matchPath(pathname, { path: clientPaths.profile.complete })) {
    return 'profile';
  }

  if (matchPath(pathname, { path: clientPaths.modelPortfolios.complete })) {
    return 'model-portfolios';
  }

  return null;
}

export function setClientSection(pathname) {
  const value = getClientSectionFromPathname(pathname);
  if (value) Sentry.setTag('section', value);
}
